export default "__VITE_ASSET__CaSLn_gr__"